import axios from 'axios'
import Vue from 'vue'
import store from "@/store";

const $http = axios.create({
    baseURL: `${process.env.VUE_APP_API_URL}/api/v1`
})
const token = localStorage.getItem('token')
if (token) {
    $http.defaults.headers.common['Authorization'] = `Bearer ${token}`
}
$http.interceptors.response.use(null, error => {
    return new Promise(function (resolve, reject) {
        const response = error.response
        if (response && response.status === 401 && !response.config.url.includes('logout')) {
            store.dispatch('auth/signOut', null, {root: true})
        }
        else {
            reject(error)
        }
    });
});
Vue.prototype.$http = $http
export default $http
